// utils/loadCashfreeScript.js
const loadCashfreeScript = () =>
  new Promise((resolve) => {
    if (document.getElementById('cashfree-script')) return resolve(true);
    const s   = document.createElement('script');
    s.id      = 'cashfree-script';
    s.src     = 'https://sdk.cashfree.com/js/v3/cashfree.js';
    s.onload  = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });

export default loadCashfreeScript;